export const MY_PROFILE = "MY_PROFILE";
export const CHANGE_PASSOWRD = "CHANGE_PASSOWRD";

export const PROFILE = "PROFILE";
export const ROLE = "ROLE";
export const SECURITY = "SECURITY";
export const NOTIFICATIONS = "NOTIFICATIONS";
export const PREFERENCES = "PREFERENCES";
